import { apiSlice } from './apiSlice';

export interface SocialLink {
  platform: string;
  url: string;
}

export const socialLinksApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSocialLinks: builder.query<{ success: boolean; data: SocialLink[] }, void>({
      query: () => ({
        url: '/social-links',
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetSocialLinksQuery } = socialLinksApi;
